// Copyright (c) 2026 Chain Capital Technologies Ltd. All rights reserved.
// See LICENSE file in the project root for full license information.

import { LocationProvider, Router, Route } from 'preact-iso';
import { Layout } from './components/layout.js';
import { Home } from './pages/home.js';
import { VaultLookup } from './pages/vault-lookup.js';
import { NotFound } from './pages/not-found.js';
import { EmbedConfirm } from './pages/embed-confirm.js';

// The router is deliberately flat (COB-389). preact-iso gives a nested
// <Router> the parent route's `rest` path to match against, and `rest` is
// only populated when the parent route matched a `/*` wildcard — under a
// `default` route it is pinned to '', which matches path="/". A site
// router nested under `default` therefore rendered Home for every URL,
// making /v/:id and NotFound unreachable. Don't re-nest.

/** The normal verifier site pages, wrapped in the banner/header/footer chrome. */
const SiteHome = () => (
  <Layout>
    <Home />
  </Layout>
);
const SiteVaultLookup = () => (
  <Layout>
    <VaultLookup />
  </Layout>
);
const SiteNotFound = () => (
  <Layout>
    <NotFound />
  </Layout>
);

export function App() {
  return (
    <LocationProvider>
      <Router>
        {/* COB-263: the confirm embed renders bare — no site chrome — so it
            sits cleanly inside the user-app modal iframe. */}
        <Route path="/embed/confirm/:id" component={EmbedConfirm} />
        <Route path="/" component={SiteHome} />
        <Route path="/v/:id" component={SiteVaultLookup} />
        <Route default component={SiteNotFound} />
      </Router>
    </LocationProvider>
  );
}
